import { useEffect } from 'react'
import { searchDateTimeSelector, setDateTimeRange } from 'search-date-time'

import featureToggles from 'shared/featureToggles'
import { withRouter } from 'i18n/utils'
import { makePurchasePendingSelector, numberOfItemsSelector } from 'basket/selectors'

import { CARDS } from '../reducers'
import {
    selectedRateIdSelector,
    ratesSelector,
    lastBookingBasketItemSelector,
    isSameTicketInBasketSelector,
    disabledCardsSelector,
    ratesErrorSelector,
    ratesAreLoadingSelector,
    currentCustomerFlowSelector,
} from '../selectors'
import { selectRate, getRates, enableCard } from '../actions'

import { validationErrorsInitialState } from './utilities'

const withRates = WrappedComponent => props => {
    const {
        grsId,
        waitingListKey,
        getRates,
        selectedRateId,
        setDateTimeRange,
        selectRate,
        rates,
        enableCard,
        areRatesPending,
        ratesError,
        currentCustomerFlow,
    } = props
    const [validationErrors, setValidationErrors] = React.useState(validationErrorsInitialState)

    const onDateRangeChange = (start, end) => {
        setDateTimeRange(start, end)
        getRates({ grsId, selectedRateId, waitingListKey })
    }

    const onRateSelected = $rateId => {
        setValidationErrors({
            ...validationErrors,
            selectRateError: false,
            isSameTicketInBasketError: false,
        })
        enableCard([CARDS.CONFIRM_VEHICLE])
        selectRate($rateId)
    }

    const filteredRates = (
        selectedRateId && waitingListKey ? rates.filter(rate => rate.$rateId === selectedRateId) : rates
    ).filter(rate => !rate.isMonthlyPass)

    const availableRates = filteredRates.filter(item => !item?.soldOut)
    const soldOutRates = filteredRates.filter(item => item?.soldOut)
    const sortedRates = availableRates.concat(soldOutRates)

    return (
        <WrappedComponent
            filteredRates={featureToggles.showSoldOutProducts ? sortedRates : availableRates}
            areRatesPending={areRatesPending}
            ratesError={ratesError}
            onRateSelected={onRateSelected}
            onDateRangeChange={onDateRangeChange}
            validationErrors={validationErrors}
            currentCustomerFlow={currentCustomerFlow}
            {...props}
        />
    )
}

export default WrappedComponent =>
    compose(
        withRouter,
        connect(
            createStructuredSelector({
                numberOfItemsInBasket: numberOfItemsSelector,
                makePurchasePending: makePurchasePendingSelector,
                selectedRateId: selectedRateIdSelector,
                rates: ratesSelector,
                range: searchDateTimeSelector,
                lastBookingBasketItem: lastBookingBasketItemSelector,
                isSameTicketInBasket: isSameTicketInBasketSelector,
                disabledCards: disabledCardsSelector,
                areRatesPending: ratesAreLoadingSelector,
                ratesError: ratesErrorSelector,
                currentCustomerFlow: currentCustomerFlowSelector,
            }),
            {
                getRates,
                selectRate,
                setDateTimeRange,
                enableCard,
            }
        )
    )(withRates(WrappedComponent))
